/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Treadmill/millIronSheets.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation5.play();
    actions.Animation5.repetitions = 1;
    actions.Animation5.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="ironSheets" geometry={nodes.ironSheets.geometry} material={materials.金屬銀} />
      </group>
    </group>
  )
}

useGLTF.preload('/Treadmill/millIronSheets.glb')
